import { ArrowUp, ArrowDown, Minus } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export interface KpiMetricCardProps {
  label: string
  value: string | number
  delta?: number
  deltaSuffix?: string
  trend?: 'up' | 'down' | 'flat'
  className?: string
}

function trendFromDelta(delta?: number): 'up' | 'down' | 'flat' {
  if (delta === undefined || delta === 0) return 'flat'
  return delta > 0 ? 'up' : 'down'
}

export function KpiMetricCard({
  label,
  value,
  delta,
  deltaSuffix = '%',
  trend,
  className,
}: KpiMetricCardProps) {
  const dir = trend ?? trendFromDelta(delta)
  const Icon = dir === 'up' ? ArrowUp : dir === 'down' ? ArrowDown : Minus
  const color =
    dir === 'up'
      ? 'text-success'
      : dir === 'down'
        ? 'text-destructive'
        : 'text-muted-foreground'

  return (
    <Card className={cn('p-4', className)}>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        {label}
      </div>
      <div className="mt-1 text-2xl font-bold text-foreground">{value}</div>
      {delta !== undefined && (
        <div
          className={cn('mt-1 flex items-center gap-1 text-xs', color)}
          aria-label={`Change: ${delta}${deltaSuffix}`}
        >
          <Icon className="h-3 w-3" aria-hidden />
          <span>
            {Math.abs(delta)}
            {deltaSuffix}
          </span>
        </div>
      )}
    </Card>
  )
}
